export const GET_MATCHES = 'GET_MATCHES';
export const MATCHES_ERROR = 'MATCHES_ERROR';
export const GET_MATCH = 'GET_MATCH';
export const MATCH_ERROR = 'MATCH_ERROR';
export const GET_COMMENTARY = 'GET_COMMENTARY';
export const COMMENTARY_ERROR = 'COMMENTARY_ERROR';
export const GET_LATEST_FEED = 'GET_LATEST_FEED';
export const LATEST_FEED_ERROR = 'LATEST_FEED_ERROR';